import React from 'react';
import List from '../../../components/community/feed/List';

const ListPage = () => {
  return (
    <List />
  )
}

export default ListPage